.heading {
  position: relative;
  scroll-margin-top: calc(var(--portal-topbar-height, 0px) + 2rem);
  display: flex;
  align-items: center;

  &:hover .anchor {
    opacity: 1;
  }
}

.anchor {
  margin-inline-start: 0.5em;
  opacity: 0;
  transition: opacity 0.2s ease;
  color: var(--color-muted);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  font-size: 0.75em;

  &:hover {
    color: var(--color-primary);
  }

  &:focus-visible {
    opacity: 1;
  }
}
